const isNew = is_new => {
    if(is_new === 1) return true;
    return false;
}

export default isNew;
